import { QueryOptions } from '@shared/fetch-utils';
import { MgSupplierItemClimateDTO } from '@retail/products/types';
import { MgItemRawDTO } from '@retail/products/types';
import { buildUrl } from '@shared/utils';
import { useMPEFetch } from '@retail/app/hooks';
import { AssortmentDTO } from '@retail/my-assortment/types';
import { mpeApi } from '@retail/mgpris/config';
import { useMgPrisConfig } from '@retail/app/stores/app-config';
import { useAuthContext } from '@retail/auth/data-access';


interface FetchAssortmentsProps {
  mgItemNumber: number;
  orgUnitId: number;
}

export function useFetchAssortmentsForMgItem(
  { mgItemNumber, orgUnitId }: FetchAssortmentsProps,
  options?: QueryOptions
) {
  const { mpe } = useMgPrisConfig();
  const { token } = useAuthContext();

  return useMPEFetch<AssortmentDTO[]>({
    method: 'GET',
    url: buildUrl({
      base: mpe.url,
      route: mpeApi.mgItems.mgItemNumber.assortments.getFullLinkPath({ mgItemNumber }),
      searchParams: { orgUnitId },
    }),
    token,
    queryKey: ['assortments-for-mg-item', mgItemNumber],
    ...options,
  });
}

export function useFetchRawMgItem(
  { mgItemNumber }: Pick<FetchAssortmentsProps, 'mgItemNumber'>,
  options?: QueryOptions
) {
  const { mpe } = useMgPrisConfig();
  const { token } = useAuthContext();

  return useMPEFetch<MgItemRawDTO>({
    method: 'GET',
    url: buildUrl({
      base: mpe.url,
      route: mpeApi.mgItems.mgItemNumber.json.getFullLinkPath({ mgItemNumber }),
    }),
    token,
    queryKey: ['json-for-mg-item', mgItemNumber],
    ...options,
  });
}

interface GWPProps {
  mgItemNumber: number;
  supplierId: number;
}

export function useFetchMgItemGWP({ mgItemNumber, supplierId }: GWPProps, options?: QueryOptions) {
  const { mpe } = useMgPrisConfig();
  const { token } = useAuthContext();

  return useMPEFetch<MgSupplierItemClimateDTO>({
    method: 'GET',
    url: buildUrl({
      base: mpe.url,
      route: mpeApi.suppliers.supplier.items.item.climateData.getFullLinkPath({
        mgItemNumber,
        supplierId,
      }),
    }),
    token,
    queryKey: ['mg-item-gwp', mgItemNumber, supplierId],
    ...options,
  });
}
